// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__aRUG8","close":"Modal_close__FkIqj","rotation":"Modal_rotation__sJWIo"};